import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Route, RouteComponentProps, Switch, withRouter } from 'react-router-dom';
import { Modal, ModalBody } from 'reactstrap';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import '../../styles/index.scss';
import Login from '../Login';
import Main from '../Main';

@inject('stores')
@observer
class App extends React.Component<RouteComponentProps> {
    public props: any;

    constructor(props: any) {
        super(props);
    }

    public render() {
        return (
            <div className="App">
                <Switch>
                    <Route exact={true} path="/" component={Login} />
                    <Route path="/login" component={Login} />
                    <Route path="/home/:list" component={Main} />
                    <Route path="/home" component={Main} />
                    <Route path="/profile" component={Main} />
                    <Route path='/admin/:task/:id' component={Main} />
                    <Route path='/admin' component={Main} />
                    <Route path='/approvals' component={Main} />
                    <Route path='/submissions' component={Main} />
                    <Route path='/reports' component={Main} />
                    <Route path='/dispatches' component={Main} />
                    <Route path='/activereports' component={Main} />
                    <Route path='/tableaureports' component={Main} />
                    {/* <Route path='/activereports' component={Main} /> */}
                    <Route path="/well/:wellId/:task/:taskId/:mainTask/:subTask" component={Main} />
                    <Route path="/well/:wellId/:task/:taskId/:mainTask" component={Main} />
                    <Route path="/well/:wellId/:task" component={Main} />
                    <Route path="/well/:wellId" component={Main} />
                </Switch>
                <Modal isOpen={this.props.stores.loading} fade={false} centered={true} size={'sm'} modalTransition={{timeout: 0}} backdropTransition={{timeout: 0}}>
                    <ModalHeader>
                        Your Request Is Being Processed
                    </ModalHeader>
                    <ModalBody style={{textAlign: 'center'}}>
                        <FontAwesomeIcon 
                            icon={faSpinner}
                            spin={true}
                            size={"8x"}
                        />
                    </ModalBody>
                </Modal>
                <div id="my-hidden-div" />
            </div>
        );
    }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/Components/App/App.tsx